import React from "react";
import { Star } from "lucide-react";

interface MentorRatingBadgeProps {
  rating: number;
  showScale?: boolean;
}

export const MentorRatingBadge: React.FC<MentorRatingBadgeProps> = ({ rating, showScale = false }) => {
  return (
    <div className="bg-[#1A2233]/80 backdrop-blur-sm rounded-full px-2 py-1 flex items-center gap-1">
      <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
      <span className="text-white text-sm font-medium">
        {rating.toFixed(1)}{showScale ? '/5' : ''}
      </span>
    </div>
  );
};
